/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseOfString } from '../../models/api-response-of-string';

export interface UserPracticesSetAllPracticesOfMappedUser$Params {
  userId?: number;
  PracticeIds?: string | null;
}

export function userPracticesSetAllPracticesOfMappedUser(http: HttpClient, rootUrl: string, params?: UserPracticesSetAllPracticesOfMappedUser$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseOfString>> {
  const rb = new RequestBuilder(rootUrl, userPracticesSetAllPracticesOfMappedUser.PATH, 'get');
  if (params) {
    rb.query('userId', params.userId, {});
    rb.query('PracticeIds', params.PracticeIds, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseOfString>;
    })
  );
}

userPracticesSetAllPracticesOfMappedUser.PATH = '/setmappeduserpractices';
